import { useLocation } from 'react-router-dom';
import RoleListView from '../components/roles/RoleListView';
import RoleFormView from '../components/roles/RoleFormView';

export interface RolesPageProps {
	createPermission?: string;
	editPermission?: string;
}

export default function RolesPage({
	createPermission,
	editPermission,
}: RolesPageProps = {}) {
	const { pathname } = useLocation();

	// /iam/roles exactly → list view
	// /iam/roles/create, /iam/roles/:id, /iam/roles/:id/edit → form view
	if (pathname !== '/iam/roles') {
		return <RoleFormView editPermission={editPermission} />;
	}

	return <RoleListView createPermission={createPermission} />;
}
